"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SocialMediaTemplate1;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SocialMediaTemplate1(props) {
  var _state$section, _state$section2, _state$section2$store, _state$section3, _state$section4, _state$section5, _state$section5$secti, _state$section6, _state$section6$media, _state$section6$media2;

  const [state, setState] = (0, _react.useState)({
    section: {}
  });
  const [isSourceWebConsole, setSource] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setState({
      section: props === null || props === void 0 ? void 0 : props.section
    });

    if ((props === null || props === void 0 ? void 0 : props.source) === "web-console") {
      setSource(true);
    }
  }, [props]);

  const onWrapperClick = dataReceived => {
    if (props.onElementClick && isSourceWebConsole) {
      props.onElementClick(_objectSpread(_objectSpread({}, dataReceived), {}, {
        templateId: props.templateId
      }));
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "social-media-template-1-container w-100 flex flex-column items-center"
  }, state !== null && state !== void 0 && (_state$section = state.section) !== null && _state$section !== void 0 && _state$section.store_image ? /*#__PURE__*/_react.default.createElement("div", {
    className: "store-image ponter relative"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: state === null || state === void 0 ? void 0 : (_state$section2 = state.section) === null || _state$section2 === void 0 ? void 0 : (_state$section2$store = _state$section2.store_image) === null || _state$section2$store === void 0 ? void 0 : _state$section2$store.url,
    alt: state === null || state === void 0 ? void 0 : (_state$section3 = state.section) === null || _state$section3 === void 0 ? void 0 : _state$section3.display_text
  }), isSourceWebConsole ? /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute hover-store-image flex justify-center items-center pointer",
    onClick: () => onWrapperClick({
      parentKey: "",
      itemIndex: null,
      keyToBeUpdated: "store_image",
      childKeyToBeReplaced: "url"
    })
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "image-edit-btn flex items-center justify-center"
  }, "Edit Image")) : null) : null, state !== null && state !== void 0 && (_state$section4 = state.section) !== null && _state$section4 !== void 0 && _state$section4.section_title ? /*#__PURE__*/_react.default.createElement("div", {
    className: "f4 b section-title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(isSourceWebConsole ? "title-hover" : ""),
    onClick: () => onWrapperClick({
      parentKey: "",
      itemIndex: null,
      keyToBeUpdated: "section_title",
      childKeyToBeReplaced: "display_text"
    })
  }, state === null || state === void 0 ? void 0 : (_state$section5 = state.section) === null || _state$section5 === void 0 ? void 0 : (_state$section5$secti = _state$section5.section_title) === null || _state$section5$secti === void 0 ? void 0 : _state$section5$secti.display_text)) : null, state !== null && state !== void 0 && (_state$section6 = state.section) !== null && _state$section6 !== void 0 && (_state$section6$media = _state$section6.media_links) !== null && _state$section6$media !== void 0 && (_state$section6$media2 = _state$section6$media.list) !== null && _state$section6$media2 !== void 0 && _state$section6$media2.length ? state.section.media_links.list.map((media, index) => {
    var _media$image;

    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "flex items-center justify-center social-media-links pointer relative",
      onClick: () => !isSourceWebConsole && window.open(media.media_url.url, "_blank")
    }, media !== null && media !== void 0 && media.image ? /*#__PURE__*/_react.default.createElement("img", {
      src: (_media$image = media.image) === null || _media$image === void 0 ? void 0 : _media$image.url,
      alt: media === null || media === void 0 ? void 0 : media.image.display_text,
      className: "absolute media-image"
    }) : null, media !== null && media !== void 0 && media.media_name ? /*#__PURE__*/_react.default.createElement("div", {
      className: "media-text tc self-center"
    }, media === null || media === void 0 ? void 0 : media.media_name.display_text) : null, isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
      className: "action-container absolute flex justify-center items-center"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "remove-btn pointer relative justify-center",
      onClick: e => {
        e.stopPropagation();
        onWrapperClick({
          parentKey: "media_links",
          itemIndex: index,
          keyToBeUpdated: "",
          childKeyToBeReplaced: "",
          operation: "delete"
        });
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://cdn.dotpe.in/kiranaStatic/icons/removeicon.png"
    }), "Remove"), /*#__PURE__*/_react.default.createElement("button", {
      className: "edit-btn pointer",
      onClick: e => {
        e.stopPropagation();
        onWrapperClick({
          parentKey: "media_links",
          itemIndex: index,
          keyToBeUpdated: "",
          childKeyToBeReplaced: ""
        });
      }
    }, "Edit")));
  }) : null, isSourceWebConsole && /*#__PURE__*/_react.default.createElement("div", {
    className: "add-new-btn flex justify-center items-center pointer",
    onClick: () => onWrapperClick({
      parentKey: "media_links",
      itemIndex: "",
      keyToBeUpdated: "",
      childKeyToBeReplaced: "",
      operation: "add"
    })
  }, "+ Add New"));
}